import React from "react";
import infoIcon from "icons/info-new-rows.svg";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { setAnonymizeUsers } from "slices/systemAdmin/actions/systemAdmin";

const AnonymiseUsersModal = () => {
  const dispatch = useDispatch();

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.ANONYMIZE_USERS));
  };

  const handleSave = () => {
    dispatch(setAnonymizeUsers(true));
  };

  const modalBody = () => (
    <div className="anonymize__users__modal">
      <div className="anonymize__users__modal__icon">
        <img src={infoIcon} alt="info icon" />
      </div>
      <div className="anonymize__users__modal__info">
        <p>
          Turning this setting on will anonymize each user’s username in Usage
          Reports. This affects all workspaces. Do you wish to proceed?
        </p>
      </div>
    </div>
  );

  return (
    <Modal
      data-testid="anonymizeUsersModal"
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <b>Anonymize Users</b>
      </Modal.Header>
      <Modal.Body>{modalBody()}</Modal.Body>
      <Modal.Footer>
        <Button
          onClick={handleSave}
          variant={buttonVariants.primary}
          data-test="saveButton"
          disabled={false}
          content="Anonymize Users"
        />
        <Button
          onClick={handleCancel}
          variant={buttonVariants.secondary}
          data-test="cancelButton"
          disabled={false}
          content="Cancel"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default AnonymiseUsersModal;
